class Contact {
  constructor() {
    this._selectedKoumoku = null;
    this.init();
    this.initConfirm();
  }

  init() {
    // ラジオの選択値を記憶するリスナーをまず設定
    const initialChecked = document.querySelector('input[name="koumoku"]:checked');
    if (initialChecked) this._selectedKoumoku = initialChecked.value;

    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name="koumoku"]')) {
        this._selectedKoumoku = e.target.value;
      }
    });

    // URLパラメータによるラジオ自動選択（リスナー設定後に実行）
    const params = new URLSearchParams(window.location.search);
    const type = params.get('type');
    if (!type) return;

    const typeMap = {
      security: '防犯製品について',
      development: '依頼開発について',
      recruitment: '採用について',
      media: 'メディアへの掲載・取材について',
      other: 'その他',
    };

    const koumokuValue = typeMap[type];
    if (!koumokuValue) return;

    const radio = document.querySelector(`[name="koumoku"][value="${koumokuValue}"]`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  initConfirm() {
    const span = document.getElementById('cf7msm_koumoku');

    // 確認ページ以外（#cf7msm_koumoku がない = 入力ページ）は何もしない
    if (!span) return;

    if (span.textContent.trim()) {
      // すでに値がある場合は即実行
      this._toggleConfirmGroups(span.textContent.trim());
    } else {
      // Webhead プラグインが JS でスパンに値をセットするまで待つ
      const observer = new MutationObserver(() => {
        const value = span.textContent.trim();
        if (value) {
          observer.disconnect();
          this._toggleConfirmGroups(value);
        }
      });
      observer.observe(span, { childList: true, characterData: true, subtree: true });

      // 5秒以内に値が来なければ監視終了
      setTimeout(() => observer.disconnect(), 5000);
    }
  }

  _toggleConfirmGroups(koumokuValue) {
    const showSecurity = koumokuValue
      .replace(/[\s\u3000]+/g, '')
      .includes('防犯製品');

    const securityGroup = document.querySelector('[data-confirm-group="security"]');
    const normalGroup = document.querySelector('[data-confirm-group="normal"]');

    if (securityGroup) securityGroup.style.display = showSecurity ? '' : 'none';
    if (normalGroup) normalGroup.style.display = showSecurity ? 'none' : '';
  }
}
